<template lang="pug">
feathers-vuex-find(service="vw-user-groups" :query="dataQuery" :fetch-query="fetchQuery" watch="query")
    v-card(slot-scope="{ items: desserts, pagination: serverPagination, isFindPending }")
        v-card-title Groups
            v-spacer
            v-text-field(v-model="searchUser" append-icon="mdi-magnify" label="Search" single-line hide-details)
            add-new-group(:type="17" @success="successMessage = true" @error="onError")
        v-data-table(
            :headers="headers"
            :loading="isFindPending"
            :items="isFindPending ? [] : desserts"
            :options.sync="pagination"
            :server-items-length="!serverPagination ? 0 : serverPagination.mostRecent.total"
            loading-text="Fetching Data..."
            item-key="group_id"
        )
            template(v-slot:item.group_name="{ item }")
                v-avatar(size="30" style="margin-right: 10px;")
                    img(:src="item.profile_picture_thumb")
                a(:href="`http://www.breakinghits.app/${item.url}`" :target="`__user-${item.id}`") {{ item.group_name }}
            template(v-slot:item.genre="{ item }") {{ item.genre | genreParser(getGenre) }}
            template(v-slot:item.date_added="{ item }") {{ item.date_added | dateFormat }}
            template(v-slot:item.status="{ item }") {{ item.status | status }}
            template(v-slot:item.actions="{ item }")
                div.d-flex.align-center
                    group-members-manager(:group-id="item.group_id" :group-name="item.group_name" class="mr-2")
                    group-invitations-manager(:group-id="item.group_id" :group-name="item.group_name" class="mr-2")
                    v-btn(icon @click="openEditDialog(item)" class="mr-2")
                        v-icon(color="blue") mdi-pencil
                    v-btn(icon @click="deleteGroup(item.group_id)")
                        v-icon(color="red") mdi-delete

        v-dialog(v-model="confirmDeleteDialog" max-width="500px")
            v-card
                v-card-title.headline Confirm Delete
                v-card-text Are you sure you want to delete this group?
                v-card-actions
                    v-spacer
                    v-btn(color="green darken-1" text @click="confirmDeleteDialog = false") Cancel
                    v-btn(color="red darken-1" text @click="confirmDelete") Delete

        v-dialog(v-model="editDialog" max-width="480px")
            v-card
                v-card-title.headline Edit Group Name
                v-card-text
                    v-text-field(v-model="editForm.group_name" label="Group Name" outlined)
                v-card-actions
                    v-spacer
                    v-btn(text @click="editDialog = false") Cancel
                    v-btn(color="primary" :loading="editLoading" @click="saveGroupName") Save

        v-snackbar(top v-model="successMessage" color="success") Successfully Created!
        v-snackbar(top v-model="error.show" color="red") {{ error.message }}
</template>

<script>
import moment from 'moment';
import { mapActions, mapGetters } from 'vuex';
import AddNewGroup from '@/components/AddNewGroup.vue';
import GroupInvitationsManager from '@/components/GroupInvitationsManager.vue';
import GroupMembersManager from '@/components/GroupMembersManager.vue';

export default {
    data() {
        return {
            confirmDeleteDialog: false,
            editDialog: false,
            editForm: { group_id: null, group_name: '' },
            editLoading: false,
            successMessage: false,
            error: {
                show: false,
                message: ''
            },
            searchUser: '',
            headers: [
                {
                    text: 'ID',
                    align: 'start',
                    sortable: true,
                    value: 'group_id'
                },
                {
                    text: 'Group Name',
                    align: 'start',
                    sortable: true,
                    value: 'group_name'
                },
                {
                    text: 'Genre',
                    align: 'start',
                    sortable: true,
                    width: 200,
                    value: 'genre'
                },
                {
                    text: 'Status',
                    align: 'start',
                    sortable: true,
                    value: 'status'
                },
                {
                    text: 'Date Registered',
                    align: 'end',
                    sortable: true,
                    value: 'date_added'
                },
                {
                    text: 'Actions',
                    align: 'center',
                    sortable: false,
                    value: 'actions'
                },
            ],
            pagination: {
                page: 1,
                itemsPerPage: 10,
                sortBy: ['date_added'],
                sortDesc: [true]
            },
            query: {},
        };
    },
    filters: {
        dateFormat(date) {
            if(date) {
                return moment(date).format('lll');
            }

            return 'n/a';
        },
        status(status) {
            switch(status) {
                case 0: return 'Inactive';
                case 1: return 'Active';
            }
        },
        genreParser(list, getGenre) {
            if(list) {
                return list.split(',').map(i => {
                    const data = parseInt(i);
                    if(isNaN(data)) {
                        return i.replace(/&amp;/g, '&');
                    } else {
                        return getGenre(data).genre;
                    }
                }).join(', ');
            }
            return '';
        }
    },
    computed: {
        extendedQuery() {
            if(this.user) {
                return {
                    // id: { $nin: [this.user.id] }
                };
            }
            return null;
        },
        searchQuery() {
            if(this.searchUser) {
                return {
                    $or: [
                        { artist_name: { $like: `%${this.searchUser}%` } },
                        { url: { $like: `%${this.searchUser}%` } },
                    ]
                };
            }
            return null;
        },
        searchDataQuery() {
            if(this.searchUser) {
                return {
                    $or: [
                        { artist_name: { $regex: new RegExp(`.*${this.escapeRegex(this.searchUser)}.*`, 'gi') } },
                        { utl: { $regex: new RegExp(`.*${this.escapeRegex(this.searchUser)}.*`, 'gi') } },
                    ]
                };
            }
            return null;
        },
        sortingQuery() {
            if(this.pagination.sortBy.length !== 0) {
                const $sort = {};
                this.pagination.sortBy.map((item, index) => {
                    switch(item) {
                        case 'group_name':
                            $sort.group_name = this.pagination.sortDesc[index] ? -1 : 1;
                            break;
                        default:
                            $sort[item] = this.pagination.sortDesc[index] ? -1 : 1;
                    }
                    
                });
                return { $sort };
            }
            return null;
        },
        dataQuery() {
            return {
                ...this.query,
                ...this.extendedQuery,
                ...this.searchDataQuery,
                $limit: this.pagination.itemsPerPage,
                $skip: (this.pagination.page-1) * this.pagination.itemsPerPage,
                ...this.sortingQuery
            };
        },
        fetchQuery() {
            return Object.assign({}, {
                ...this.query,
                ...this.extendedQuery,
                // $populate: true
            }, {
                ...this.searchQuery,
                $limit: this.pagination.itemsPerPage,
                $skip: (this.pagination.page-1) * this.pagination.itemsPerPage,
                ...this.sortingQuery
            });
        },
        ...mapGetters('bh-mgenre', { getGenre: 'get' })
    },
    created() {
        this.getAllGenre({
            query: { $limit: 100 }
        });
    },
    methods: {
        escapeRegex(string) {
            return string.replace(/[-/\\^$*+?.()|[\]{}]/g, '\\$&');
        },
        onError(err) {
            this.error.show = true;
            this.error.message = err.message;
        },
        deleteGroup(id) {
            this.confirmDeleteDialog = true;
            this.groupIdToDelete = id;
        },
        confirmDelete() {
            this.deleteTargetGroup(this.groupIdToDelete).then(() => {
                this.$store.commit('vw-user-groups/removeItem', this.groupIdToDelete);
            }).catch(err => {
                this.onError(err);
            }).finally(() => {
                this.confirmDeleteDialog = false;
            });
        },
        openEditDialog(item) {
            this.editForm = { group_id: item.group_id, group_name: item.group_name };
            this.editDialog = true;
        },
        async saveGroupName() {
            this.editLoading = true;
            try {
                await this.patchGroup([this.editForm.group_id, { group_name: this.editForm.group_name }]);
                this.$store.commit('vw-user-groups/removeItem', this.editForm.group_id);
                this.editDialog = false;
            } catch (err) {
                this.onError(err);
            } finally {
                this.editLoading = false;
            }
        },
        ...mapActions('bh-mgenre', { getAllGenre: 'find' }),
        ...mapActions('bh-user-groups', { deleteTargetGroup: 'remove', getGroupByUserId: 'find', patchGroup: 'patch' })
    },
    components: {
        AddNewGroup,
        GroupInvitationsManager,
        GroupMembersManager
    }
}
</script>